module.exports = __webpack_public_path__ + "static/media/increse.4d0b2e89.svg";